( function( global, $ ) {

    var $productGallery = $('[gr-product-gallery]');
    var $productGalleryNav = $('[gr-product-gallery-nav]');

    $productGallery.on('init', function(event, slick) {
        var title = $productGallery.find('.slick-current img').attr("alt");
        $productGallery.append('<div class="slick-counter">'+ parseInt(slick.currentSlide + 1, 10) +' / '+ slick.slideCount +'</div>');
        $productGallery.append('<div class="slick-caption">'+ title +'</div>');
    });

    $productGallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true,
        asNavFor: '[gr-product-gallery-nav]'
    });

    $productGallery.on('afterChange', function(event, slick) {
        var title = $productGallery.find('.slick-current img').attr("alt");
        var $captionElement = $productGallery.find('.slick-caption');
        $productGallery.find('.slick-counter').html(slick.currentSlide + 1 +' / '+slick.slideCount);
        if (title) $captionElement.html(title);
        else $captionElement.empty();
    });

    $productGalleryNav.slick({
        rows: 0, // related issue: https://github.com/kenwheeler/slick/issues/3149
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: '[gr-product-gallery]',
        prevArrow: '<button class="slider__arrow slider__arrow--secondary slider__prev" type="button" aria-label="Previous"></button>',
        nextArrow: '<button class="slider__arrow slider__arrow--secondary slider__next" type="button" aria-label="Next"></button>',
        responsive:
        [
            {
                breakpoint: parseInt(window.groots.sassBreakpoints['md'], 10),
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: parseInt(window.groots.sassBreakpoints['xs'], 10),
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

}( window.groots, jQuery, require('slick-carousel') ));
